import { useEffect } from "react";
import { useLocation } from "react-router-dom";

export default function ScrollToTop() {
  const { pathname, hash, state } = useLocation();

  useEffect(() => {
    // ✅ allow special flows to manage scroll themselves
    if (state?.scrollToQuote) return;
    if (state?.preserveScroll) return;

    // ✅ hash navigation support: /page#section
    if (hash) {
      const id = hash.substring(1);
      requestAnimationFrame(() => {
        const el = document.getElementById(id);
        if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
        else window.scrollTo(0, 0);
      });
      return;
    }

    // ✅ default: always go to top on route change
    window.scrollTo(0, 0);
  }, [pathname, hash, state]);

  return null;
}

